enum DateComplexConst {
    Today = 'today',
    Now = 'now',
    MonthStart = 'monthstart',
    MonthEnd = 'monthend'
}

export default DateComplexConst;